const CONSUMPTION_TYPE_OPTIONS = [
  { value: "AnnualConsumption", label: "Annual Consumption" },
  { value: "MaximumDemandDiversified", label: "Maximum Demand (Diversified)" },
  { value: "MaximumDemand", label: "Maximum Demand (Fixed)" },
];

export default CONSUMPTION_TYPE_OPTIONS;
